import Vue from 'vue';
import { ChannelTileSize } from '@lumiere/db/types';
export default Vue.extend({
    name: 'ChannelVideosGridLayout',
    props: {
        withSidepanel: {
            type: Boolean,
            required: true,
        },
        tileSize: {
            type: String,
            required: true,
        },
    },
    computed: {
        cssClass() {
            const size = this.tileSize;
            const map = {
                [ChannelTileSize.Small]: 4,
                [ChannelTileSize.Medium]: 3,
                [ChannelTileSize.Large]: 2,
            };
            const key = map[size];
            const classObj = {};
            classObj[`channel-videos-${key}col`] = true;
            classObj[`channel-videos-${key}col--with-sidepanel`] = true;
            return classObj;
        },
    },
    components: {},
});
